var isDesktop = require("./is-desktop");
var isTablet = require("./is-tablet");
var isMobile = require("./is-mobile");

function isHandheld() {
    return (!isDesktop() && (isTablet() || isMobile()));
}

module.exports = isHandheld;